<template>
  <div>
    <v-row class="fill-height">
      <v-col style="text-align: -webkit-center">
        <v-card
          style="border: none !important ; width: 240px; height: 215"
          outlined
          class="r0 pa-0"
        >
          <v-card
            outlined
            style="padding: 13px"
            :style="{ background: planSelect.color }"
            class="r0 text-center color-white"
          >
            <h2>
              {{ planSelect.title }}
            </h2>
          </v-card>
          <v-card-title style="padding: 12px 0px 35px 0px">
            <v-row class="fill-height flex-column text-center">
              <h1 class="mt-5 ma-0" style="font-size: 40px">
                {{ planSelect.priceNumber | numberFormat }} ฿
              </h1>
              <h1 class="mt-5 ma-0 light-weight">
                {{ planSelect.piecesNumber }} {{ $t('pieces') }}
              </h1>
              <h2 class="mt-5">
                {{ $t(planSelect.piecesText) }}
              </h2>
              <!-- <small>( 30 {{ $t("days") }} )</small> -->
            </v-row>
          </v-card-title>
        </v-card>

        <v-card
          style="border: none !important ; width: 240px"
          outlined
          class="mt-5 r0 pa-0"
        >
          <v-card-title>
            <v-row class="fill-height flex-column">
              <h5 class="light-weight">
                {{ $t('Add one piece.') }}
              </h5>
              <h2>
                69
                <span style="font-size: 18px" class="light-weight">{{
                  $t('Baht')
                }}</span>
              </h2>
              <h4 class="light-weight" style="font-size: 14px">
                {{ $t('* According to the main package *') }}
              </h4>
              <!-- <h4 v-if="upSale">
                ถ้าซื้อครบ 5 ชิ้นจะได้ราคาโปรโมชั่น 5 ชิ้นเพียง 249
              </h4> -->
            </v-row>
          </v-card-title>
          <!-- <v-btn
            v-if="!toggleBuy"
            @click="buyAddOn"
            outlined
            rounded
            class="btn-custom bg-plan-btn mb-3"
            style="width: 93%; height: 28px;"
          >
            {{ $t("Buy now") }}
          </v-btn> -->
          <div class="mb-2" style="width: 100%; display: flex">
            <h6 class="mb-0 ml-4 mr-3 mt-3">{{ $t('Buy total') }}</h6>
            <v-btn
              style="height: 23px; width: 23px"
              class="mt-2 color-white bg-secondary"
              icon
              outlined
              small
              @click="minus"
            >
              <v-icon style="font-size: 16px">mdi-minus</v-icon></v-btn
            >
            <v-text-field
              style="width: 50px; font-size: 18px; text-align-last: center"
              class="mb-2 mr-2 ml-2"
              :value="count"
              disabled
              dense
              outlined
              hide-details="true"
            ></v-text-field>
            <v-btn
              icon
              outlined
              small
              class="mt-2 mr-2 color-white bg-secondary"
              style="height: 23px; width: 23px"
              @click="plus"
            >
              <v-icon style="font-size: 18px">mdi-plus</v-icon></v-btn
            >
            <h6 class="mb-0 mr-3 mt-3">{{ $t('pieces') }}</h6>
          </div>
        </v-card>
      </v-col>
      <!-- <v-icon style="font-size: 70px" class="ma-auto">mdi-plus</v-icon> -->
      <!-- <v-col style="text-align: -webkit-center;">
        <v-card
          style="border:none !important ;width: 240px; height: 100%;"
          outlined
          class="r0 pa-0"
        >
          <v-card
            outlined
            style="padding: 13px; background:#C9C9C9; border:none !important"
            class="r0 text-center color-white"
          >
            <h2 class="light-weight">
              Extra
            </h2>
          </v-card>
          <v-card-title style="line-height: 1.5rem; place-content: center; padding: 13px 10px;">
            <h3 class="light-weight" style="justify-content: center;">
              {{ $t("Add one piece.") }}
            </h3>
            <h1 style="font-size: 80px; font-weight: 400" class="color-primary">
              69
            </h1>
            <h4 class="light-weight" style="margin-top: 55px;">{{ $t("Baht") }}</h4>

            <h4 class="light-weight" style="font-size: 14px">
              {{ $t("* According to the main package *") }}
            </h4>
            <template>
              <v-btn v-if="!toggleBuy" class="btn-custom-r0 mt-6" @click="buyAddOn">
                {{ $t("Buy now") }}</v-btn
              >
              <div v-if="toggleBuy" class="mb-2" style="width: 100%; display: contents;">
                <p class="mb-0 mr-2">{{ $t("Buy total") }}</p>
                <v-btn class="color-white bg-secondary" icon outlined small @click="minus">
                  <v-icon>mdi-minus</v-icon></v-btn
                >
                <v-text-field
                  style="width: 50px;
                  border-radius: 10px 10px 0px;
                  font-size: 33px;
                  font-weight: 300;
                  margin-bottom: 10px;"
                  class="mt-2 mr-2 ml-2"
                  :value="count"
                  disabled
                  dense
                  outlined
                  hide-details="true"
                ></v-text-field>
                <v-btn icon outlined small class="mr-2 color-white bg-secondary" @click="plus">
                  <v-icon>mdi-plus</v-icon></v-btn
                >
                <span>{{ $t("pieces") }}</span>
              </div>
            </template>
          </v-card-title>
        </v-card>
      </v-col> -->
      <v-icon style="font-size: 70px" class="ma-auto">mdi-equal</v-icon>
      <v-col style="text-align: -webkit-center; align-self: center">
        <v-card
          style="border: none !important ; width: 240px"
          outlined
          class="r0 pa-0"
        >
          <v-card
            outlined
            style="padding: 13px"
            class="r0 text-center bg-secondary color-white"
          >
            <h2 class="light-weight">Total</h2>
          </v-card>
          <v-card-title style="padding: 13px 14px">
            <v-row class="fill-height flex-column text-center pa-2">
              <!-- <h3 class="ma-0 light-weight">{{ planSelect.title }}</h3>
              <h2 class=" ma-0 light-weight">
                {{ planSelect.priceNumber | numberFormat }} ฿
                <strong style="font-size: 30px;">x {{ planSelect.piecesNumber }}</strong>
              </h2> -->
              <!-- <div v-if="this.count !== 0">
                <h2 class="light-weight">+</h2>
                <h3 class="ma-0 light-weight">
                  Extra package <strong style="font-size: 30px;">x {{ this.count }}</strong>
                </h3>
              </div> -->
              <!-- <div class="text-center"><h2>=</h2></div> -->
              <h2 class="mb-3 mt-3">
                {{ parseInt(planSelect.piecesNumber) + count }}
                {{ $t('pieces') }}
              </h2>
              <h1 class="ma-0 mb-3" style="font-size: 40px">
                {{ total | numberFormat }} ฿
              </h1>
              <template>
                <div class="mt-4 text-center">
                  <v-dialog v-model="dialog" persistent max-width="800px">
                    <template #activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        style="font-size: 30px; font-weight: 400; width: 100%"
                        outlined
                        class="btn-custom bg-two-tone"
                        @click="setCreditCard"
                        v-on="on"
                        >{{ $t('Pay') }}</v-btn
                      >
                    </template>
                    <v-card style="padding-bottom: 20px">
                      <div
                        class="pointer"
                        style="
                          float: right;
                          margin-right: 30px;
                          margin-top: 10px;
                        "
                      >
                        <v-icon @click="dialog = false">mdi-close</v-icon>
                      </div>
                      <v-card-title
                        v-if="dialog"
                        style="place-content: center; display: block"
                      >
                        <credit-card
                          v-model="request"
                          @closeDialog="closeDialog"
                        ></credit-card> </v-card-title
                    ></v-card>
                  </v-dialog>
                </div>
              </template>
            </v-row>
          </v-card-title>
        </v-card>
        <div class="mt-2">
          *
          {{
            $t(
              'The system will automatically calculate the lowest price from the promotion price.'
            )
          }}
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CreditCard from '../components/account/CreditCard'
export default {
  components: {
    CreditCard
  },
  computed: {
    ...mapGetters({
      templateSelect: 'lineRichmenuManager/getTemplateSelect',
      clickTrial: 'lineRichmenuManager/getClickTrial',
      IdCreditCard: 'packagePlan/getIdCreditCard',
      GroupId: 'lineRichmenuManager/getGroupId'
    })
  },
  props: { value: Object },
  data() {
    return {
      planSelect: this.value,
      toggleBuy: false,
      count: 0,
      total: 0,
      profile: null,
      dialog: false,
      gbpReferenceNo: '',
      request: {},
      upSale: false
    }
  },
  mounted() {
    this.total = this.value.priceNumber
    this.profile = JSON.parse(localStorage.getItem('profile'))
  },
  methods: {
    checkPrice(totalpiece) {
      let temp_amount = totalpiece
      let price = 0
      if (temp_amount >= 50) {
        let x = temp_amount / 50 // 1.16
        price += Math.floor(x) * 1999

        temp_amount = temp_amount % 50
      }

      if (temp_amount >= 5) {
        let x = temp_amount / 5 // 1.16
        price += Math.floor(x) * 239

        temp_amount = temp_amount % 5
      }

      if (temp_amount >= 2) {
        let x = temp_amount / 2 // 1.16

        price += Math.floor(x) * 99

        temp_amount = temp_amount % 2
      }

      if (temp_amount >= 1) {
        price += 69
      }
      this.total = price
    },
    plus() {
      this.count = this.count + 1
      var totalpiece = parseInt(this.planSelect.piecesNumber) + this.count
      this.checkPrice(totalpiece)
    },
    buyAddOn() {
      this.plus()
      this.toggleBuy = true
    },
    closeDialog() {
      this.dialog = false
    },
    minus() {
      if (this.count > 0) {
        this.count = this.count - 1
        var totalpiece = parseInt(this.planSelect.piecesNumber) + this.count
        this.checkPrice(totalpiece)
      }
    },
    async setCreditCard() {
      // if (this.$route.params.groupID === "1") {
      this.request = {
        service: 'line_richmenu',
        amount: parseFloat(this.total),
        payment: {
          type: 'credit_card',
          credit_card_id: this.IdCreditCard
        },
        action: {
          type: 'buy',
          name: this.planSelect.piecesNumber,
          package: parseInt(this.planSelect.priceNumber),
          addon: this.count,
          trial_line_richmenu_id: null,
          price: parseFloat(this.total),
          amount: parseInt(this.planSelect.piecesNumber) + this.count
        }
      }
      // } else {
      //   this.request = {
      //     service: "line_richmenu",
      //     amount: parseFloat(this.total),
      //     payment: {
      //       type: "credit_card",
      //       credit_card_id: this.IdCreditCard,
      //     },
      //     action: {
      //       type: "extend",
      //       line_richmenu_package_id: this.$route.params.groupID,
      //       package: parseInt(this.planSelect.priceNumber),
      //       addon: this.count,
      //       price: parseFloat(this.total),
      //       amount: parseInt(this.planSelect.piecesNumber) + this.count,
      //     },
      //   };
      // }
    }
  }
}
</script>

<style lang="scss" scoped></style>
